var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11C19 13.7614 16.7614 16 14 16C11.2386 16 9 13.7614 9 11C9 8.23858 11.2386 6 14 6C16.7614 6 19 8.23858 19 11Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V2C16 1.44772 15.5523 1 15 1H2C1.44772 1 1 1.44772 1 2V10M8 13H2C1.44772 13 1 12.5523 1 12V10M14 8V11M14 14V11M14 11H11M14 11H17M1 10L5.5 5L7 7M19 11C19 13.7614 16.7614 16 14 16C11.2386 16 9 13.7614 9 11C9 8.23858 11.2386 6 14 6C16.7614 6 19 8.23858 19 11ZM11.5 4V4C11.7761 4 12 3.77614 12 3.5V3.5C12 3.22386 11.7761 3 11.5 3V3C11.2239 3 11 3.22386 11 3.5V3.5C11 3.77614 11.2239 4 11.5 4Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimage);
export default __webpack_public_path__ + "static/media/addimage.5ac39c99ba9ccd0200d88fdefa5f62de.svg";
export { ForwardRef as ReactComponent };